<template>
  <v-dialog
    v-model="show"
    max-width="500px"
    scrollable
    persistent
  >
    <v-card :loading="formProcessing">
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="state_abbr"
                  required
                  label="State Abbreviation"
                  disabled
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-switch
                  v-model="blocked"
                  label="Blocked in Waterfall"
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-switch
                  v-model="cp_blocked"
                  label="Blocked in Customer Portal"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="close()"
        >
          Cancel
        </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { useVuelidate } from '@vuelidate/core';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Object,
      default() {
        return {
          id: null,
          state_abbr: '',
          blocked: false,
          cp_blocked: false,
        };
      },
    },
  },
  setup() { return { v$: useVuelidate() }; },
  validations: {
    blocked: {
      required: true,
    },
    cp_blocked: {
      required: true,
    },
  },
  data() {
    return {
      valid: false,
      blocked: false,
      cp_blocked: false,
      formProcessing: false,
      state_abbr: '',
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formTitle() {
      const newOrUpdate = this.isNewItem ? 'New' : 'Update';
      return `${newOrUpdate} Blocked State`;
    },
    isNewItem() {
      // currently returning false since we do NOT allow UI to create or delete states
      return false;
    },
    employerNameErrors() {
      const errors = [];

      if (!this.v$.blocked.$dirty && !this.v$.cp_blocked.$dirty) {
        return errors;
      }

      if (this.v$.blocked.required.$invalid) {
        errors.push('Blocked in Waterfall is required');
      }

      if (this.v$.cp_blocked.required.$invalid) {
        errors.push('Blocked in Customer Portal is required');
      }

      return errors;
    },
  },
  watch: {
    editedItem() {
      // note: `state_abbr` table has no ID column
      // this.id = this.editedItem.id;
      this.blocked = this.editedItem.blocked;
      this.cp_blocked = this.editedItem.cp_blocked;
      this.state_abbr = this.editedItem.state_abbr;
    },
  },
  methods: {
    ...mapActions('notification', ['setNotification']),

    save() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.formProcessing = true;
        let request = '';
        const data = {
          state_abbr: this.state_abbr,
          blocked: this.blocked,
          cp_blocked: this.cp_blocked,
        };

        if (this.isNewItem) {
          // request = this.$axios.post('/api/v1/bad-employer', data);
          // no api route to create a new Blocked State
        } else {
          request = this.$axios.put(`/api/v1/blocked-state/${this.editedItem.state_abbr}`, data);
        }

        request
          .then((res) => {
            this.$emit('item-saved');

            this.setNotification({
              message: `${res.data.state_abbr} has been saved.`,
              color: 'green',
            });
          })
          .catch(() => {
            this.setNotification({
              message: 'There was an error processing your request.',
              color: 'red',
            });
          })
          .then(() => {
            this.formProcessing = false;

            this.close();
          });
      }
    },
    close() {
      this.v$.$reset();

      this.$emit('close-modal');

      this.state_abbr = '';
      this.blocked = false;
      this.cp_blocked = false;
    },
  },
};
</script>

<style></style>
